import { render, staticRenderFns } from "./SubscriptionStatisticsReport.vue?vue&type=template&id=2faa1e71&"
import script from "./SubscriptionStatisticsReport.vue?vue&type=script&lang=js&"
export * from "./SubscriptionStatisticsReport.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionStatisticsReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports